module.exports = __webpack_public_path__ + "img/fwx9.baf9f8f9.png";